import { render, staticRenderFns } from "./aLLCarList.vue?vue&type=template&id=28a490b8&scoped=true&"
import script from "./aLLCarList.vue?vue&type=script&lang=js&"
export * from "./aLLCarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a490b8",
  null
  
)

export default component.exports